// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 9269 ? "0b7b90cd" : chunkId) + "." + {"5322":"0e66cee3529e0330","9269":"28b56bc0d2a5ffaf"}[chunkId] + ".js";
};